"use strict";
/*
 *
 *  When using constants from this file, prefer to use enums. Constants are only for backward compatibility.
 *
 * */
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarmTransferRoomStatus = exports.ArMeasurementActionTypesEnum = exports.AppLauncherTypesEnum = exports.ObserverStatusMethod = exports.ObserverInvitationMethod = exports.SURVEY_ANSWER_MAX_LENGTH = exports.SWITCH_MODE_REASONS_MAP = exports.TEXT_HISTORY_ROOM_TYPES = exports.SESSION_SOURCE_MAP = exports.RECORDING_STATUS = exports.SESSION_ECOSYSTEM = exports.SESSION_SOURCE = exports.referrers = exports.supportCheckResults = exports.userTypes = exports.failureTriggerActions = exports.userInteractionTriggerActions = exports.switchModeReasons = exports.modes = exports.inviteMethods = exports.reasonForClosing = exports.EVE_SESSION_STATUS = exports.EVE_WARM_TRANSFER_REQUEST_STEPS = exports.EVE_SUCCESS_STEPS = exports.VERIZON_STEPS_ENUMS = exports.FRONTIER_STEPS_ENUMS = exports.STEPS_ENUM = exports.MeasurementUnits = exports.LinkOpeningMode = exports.AnalyzedFlowTypes = exports.WarmTransferInitiator = exports.eveCodesMap = exports.EveReportStepCodes = exports.PhotoStreamReasonKeys = exports.counters = exports.Referrer = exports.SupportCheckResult = exports.FailureTriggerAction = exports.RECORDING_MODES = exports.UserInteractionTriggerAction = exports.SwitchModeReason = exports.ModePriority = exports.FlowType = exports.MeetingModeAbbreviation = exports.MeetingMode = exports.AddressTypesEnum = exports.InviteMethod = exports.ReasonForClosing = exports.ClosedByTypes = exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType["backend"] = "backend";
    UserType["dashboard"] = "dashboard";
    UserType["supervisor"] = "supervisor";
    UserType["client"] = "client";
})(UserType = exports.UserType || (exports.UserType = {}));
var ClosedByTypes;
(function (ClosedByTypes) {
    ClosedByTypes["noOne"] = "NO_ONE";
    ClosedByTypes["dashboard"] = "DASHBOARD";
    ClosedByTypes["system"] = "SYSTEM";
    ClosedByTypes["mobile"] = "MOBILE";
    ClosedByTypes["chat"] = "CHAT";
    ClosedByTypes["simpleApi"] = "SIMPLE_API";
})(ClosedByTypes = exports.ClosedByTypes || (exports.ClosedByTypes = {}));
var ReasonForClosing;
(function (ReasonForClosing) {
    ReasonForClosing["timeout"] = "TIMEOUT";
    ReasonForClosing["cancelled"] = "CANCELLED";
    ReasonForClosing["notSpecified"] = "NOT_SPECIFIED";
    ReasonForClosing["warmTransfer"] = "WARM_TRANSFER";
})(ReasonForClosing = exports.ReasonForClosing || (exports.ReasonForClosing = {}));
//NOTE:InviteMethod is DEPRECATED and kept here for backward compatibility
var InviteMethod;
(function (InviteMethod) {
    InviteMethod["SMS"] = "SMS";
    InviteMethod["EMAIL"] = "EMAIL";
    InviteMethod["LINK"] = "LINK";
    InviteMethod["WHATSAPP"] = "WHATSAPP";
    InviteMethod["NONE"] = "NONE";
})(InviteMethod = exports.InviteMethod || (exports.InviteMethod = {}));
var AddressTypesEnum;
(function (AddressTypesEnum) {
    AddressTypesEnum["SMS"] = "SMS";
    AddressTypesEnum["EMAIL"] = "EMAIL";
    AddressTypesEnum["LINK"] = "LINK";
    AddressTypesEnum["WHATSAPP"] = "WHATSAPP";
    AddressTypesEnum["NONE"] = "NONE";
    AddressTypesEnum["INVITE_BY_CODE"] = "INVITE_BY_CODE";
    AddressTypesEnum["OBSERVE"] = "OBSERVE";
    AddressTypesEnum["OFFLINE"] = "OFFLINE";
})(AddressTypesEnum = exports.AddressTypesEnum || (exports.AddressTypesEnum = {}));
var MeetingMode;
(function (MeetingMode) {
    MeetingMode["init"] = "INIT";
    MeetingMode["images"] = "IMAGES";
    MeetingMode["video"] = "VIDEO";
    MeetingMode["screen"] = "SCREEN";
    MeetingMode["appSharing"] = "APPLICATION_SHARING";
    MeetingMode["oneClick"] = "ONE_CLICK";
    MeetingMode["coBrowsing"] = "CO_BROWSING";
    MeetingMode["visualJourney"] = "VISUAL_JOURNEY";
    MeetingMode["desktopSharing"] = "DESKTOP_SHARING";
    MeetingMode["faceMeet"] = "FACE_MEET";
    MeetingMode["videoApplication"] = "VIDEO_APPLICATION";
})(MeetingMode = exports.MeetingMode || (exports.MeetingMode = {}));
var MeetingModeAbbreviation;
(function (MeetingModeAbbreviation) {
    MeetingModeAbbreviation["visualJourney"] = "VJ";
})(MeetingModeAbbreviation = exports.MeetingModeAbbreviation || (exports.MeetingModeAbbreviation = {}));
var FlowType;
(function (FlowType) {
    FlowType["live"] = "LIVE";
    FlowType["fs"] = "FIELD_SERVICES";
    FlowType["selfService"] = "SELF_SERVICE";
})(FlowType = exports.FlowType || (exports.FlowType = {}));
var ModePriority;
(function (ModePriority) {
    ModePriority["PRIMARY"] = "primary";
    ModePriority["SECONDARY"] = "secondary";
})(ModePriority = exports.ModePriority || (exports.ModePriority = {}));
var SwitchModeReason;
(function (SwitchModeReason) {
    SwitchModeReason["initiation"] = "INITIATION";
    SwitchModeReason["updateUserModeInfo"] = "USER_MODE_INFO_UPDATE";
    SwitchModeReason["userInteraction"] = "USER_INTERACTION";
    SwitchModeReason["failure"] = "FAILURE";
})(SwitchModeReason = exports.SwitchModeReason || (exports.SwitchModeReason = {}));
var UserInteractionTriggerAction;
(function (UserInteractionTriggerAction) {
    UserInteractionTriggerAction["buttonClickDuringInitiation"] = "BUTTON_CLICK_DURING_INITIATION";
    UserInteractionTriggerAction["buttonClickDuringSession"] = "BUTTON_CLICK_DURING_SESSION";
    UserInteractionTriggerAction["bandwidthPopup"] = "BANDWIDTH_POPUP";
})(UserInteractionTriggerAction = exports.UserInteractionTriggerAction || (exports.UserInteractionTriggerAction = {}));
var RECORDING_MODES;
(function (RECORDING_MODES) {
    RECORDING_MODES["AUTOMATIC"] = "automatic";
    RECORDING_MODES["MANUAL"] = "manual";
})(RECORDING_MODES = exports.RECORDING_MODES || (exports.RECORDING_MODES = {}));
var FailureTriggerAction;
(function (FailureTriggerAction) {
    FailureTriggerAction["dashboardNetworkIssue"] = "DASHBOARD_NETWORK_ISSUE";
    FailureTriggerAction["clientNetworkIssue"] = "CLIENT_NETWORK_ISSUE";
    FailureTriggerAction["unableToPublish"] = "UNABLE_TO_PUBLISH";
    FailureTriggerAction["lowBandwidthConnection"] = "LOW_BANDWIDTH_CONNECTION";
})(FailureTriggerAction = exports.FailureTriggerAction || (exports.FailureTriggerAction = {}));
var SupportCheckResult;
(function (SupportCheckResult) {
    SupportCheckResult["normal"] = "NORMAL";
    SupportCheckResult["chromeRedirection"] = "CHROME_REDIRECTION";
    SupportCheckResult["unsupportedWhenChromeRedirectionFail"] = "UNSUPPORTED_WHEN_REDIRECTION_FAILED";
    SupportCheckResult["notSupported"] = "NOT_SUPPORTED";
})(SupportCheckResult = exports.SupportCheckResult || (exports.SupportCheckResult = {}));
var Referrer;
(function (Referrer) {
    Referrer["ANDROID_APPLICATION"] = "aa";
    Referrer["IOS_APPLICATION"] = "ia";
})(Referrer = exports.Referrer || (exports.Referrer = {}));
// Supported room counters
var counters;
(function (counters) {
    counters["sentImages"] = "sentImages";
    counters["receivedImages"] = "receivedImages";
    counters["receivedVideos"] = "receivedVideos";
    counters["snappedImages"] = "snappedImages";
    counters["savedImages"] = "savedImages";
    counters["annotatedImages"] = "annotatedImages";
    counters["clientReceivedImages"] = "clientReceivedImages";
    counters["clientSentImages"] = "clientSentImages";
    counters["clientSentVideos"] = "clientSentVideos";
    counters["smsSent"] = "smsSent";
    counters["smsDelivered"] = "smsDelivered";
    counters["visualJourneyTotalImagesUploaded"] = "visualJourneyTotalImagesUploaded";
})(counters = exports.counters || (exports.counters = {}));
// supported photo stream reasons
var PhotoStreamReasonKeys;
(function (PhotoStreamReasonKeys) {
    PhotoStreamReasonKeys["ACCOUNT_VIDEO_DISABLED"] = "ACCOUNT_VIDEO_DISABLED";
    PhotoStreamReasonKeys["IOS_DEVICE"] = "IOS_DEVICE";
    PhotoStreamReasonKeys["VIDEO_NOT_SUPPORTED"] = "VIDEO_NOT_SUPPORTED";
    PhotoStreamReasonKeys["WEBRTC_NOT_SUPPORTED"] = "WEBRTC_NOT_SUPPORTED";
    PhotoStreamReasonKeys["IOS_WITHOUT_WEBRTC_CAPS"] = "IOS_WITHOUT_WEBRTC_CAPS";
    PhotoStreamReasonKeys["BLACKLISTED_DEVICE"] = "BLACKLISTED_DEVICE";
    PhotoStreamReasonKeys["CHROME_FALLBACK_FAILED"] = "CHROME_FALLBACK_FAILED";
    PhotoStreamReasonKeys["CHROME_FALLBACK_SKIPPED"] = "CHROME_FALLBACK_SKIPPED";
    PhotoStreamReasonKeys["WINDOWS_DEVICE"] = "WINDOWS_DEVICE";
    PhotoStreamReasonKeys["CAMERA_BLOCKED_TIMEOUT"] = "CAMERA_BLOCKED_TIMEOUT";
    PhotoStreamReasonKeys["CAMERA_BLOCKED"] = "CAMERA_BLOCKED";
    PhotoStreamReasonKeys["VIDEO_CONNECTION_ERROR"] = "VIDEO_CONNECTION_ERROR";
    PhotoStreamReasonKeys["CLIENT_VIDEO_CONNECTION_ERROR"] = "CLIENT_VIDEO_CONNECTION_ERROR";
    PhotoStreamReasonKeys["AGENT_VIDEO_CONNECTION_ERROR"] = "AGENT_VIDEO_CONNECTION_ERROR";
    PhotoStreamReasonKeys["CAMERA_UNABLE_TO_PUBLISH_VIDEO"] = "CAMERA_UNABLE_TO_PUBLISH_VIDEO";
    PhotoStreamReasonKeys["BUTTON_CLICK"] = "BUTTON_CLICK";
    PhotoStreamReasonKeys["LOW_BANDWIDTH_CONNECTION"] = "LOW_BANDWIDTH_CONNECTION";
})(PhotoStreamReasonKeys = exports.PhotoStreamReasonKeys || (exports.PhotoStreamReasonKeys = {}));
var EveReportStepCodes;
(function (EveReportStepCodes) {
    EveReportStepCodes["NEXT"] = "NEXT";
    EveReportStepCodes["BACK"] = "BACK";
    EveReportStepCodes["WARM_TRANSFER"] = "WARM_TRANSFER";
    EveReportStepCodes["ERROR"] = "ERROR";
    EveReportStepCodes["SKIP"] = "SKIP";
    EveReportStepCodes["LOADED"] = "LOADED";
})(EveReportStepCodes = exports.EveReportStepCodes || (exports.EveReportStepCodes = {}));
var eveCodesMap;
(function (eveCodesMap) {
    eveCodesMap["NEXT"] = "Next";
    eveCodesMap["BACK"] = "Back";
    eveCodesMap["WARM_TRANSFER"] = "Warm Transfer";
    eveCodesMap["ERROR"] = "Error";
    eveCodesMap["SKIP"] = "Skip";
    eveCodesMap["LOADED"] = "Loaded";
})(eveCodesMap = exports.eveCodesMap || (exports.eveCodesMap = {}));
var WarmTransferInitiator;
(function (WarmTransferInitiator) {
    WarmTransferInitiator["CUSTOMER"] = "CUSTOMER";
    WarmTransferInitiator["APPLICATION"] = "APPLICATION";
})(WarmTransferInitiator = exports.WarmTransferInitiator || (exports.WarmTransferInitiator = {}));
var AnalyzedFlowTypes;
(function (AnalyzedFlowTypes) {
    AnalyzedFlowTypes["UNBOXING"] = "unboxing";
    AnalyzedFlowTypes["TROUBLESHOOTING"] = "troubleshooting";
})(AnalyzedFlowTypes = exports.AnalyzedFlowTypes || (exports.AnalyzedFlowTypes = {}));
var LinkOpeningMode;
(function (LinkOpeningMode) {
    LinkOpeningMode["defaultBrowser"] = "DEFAULT_BROWSER";
    LinkOpeningMode["store"] = "STORE";
})(LinkOpeningMode = exports.LinkOpeningMode || (exports.LinkOpeningMode = {}));
var MeasurementUnits;
(function (MeasurementUnits) {
    MeasurementUnits["Inch"] = "Inch";
    MeasurementUnits["Cm"] = "CM";
})(MeasurementUnits = exports.MeasurementUnits || (exports.MeasurementUnits = {}));
var STEPS_ENUM;
(function (STEPS_ENUM) {
    STEPS_ENUM["GUIDANCE"] = "GUIDANCE";
    STEPS_ENUM["REAR_ANALYZE"] = "REAR_ANALYZE";
    STEPS_ENUM["REAR_ANALYZE_VERIFY"] = "REAR_ANALYZE_VERIFY";
    STEPS_ENUM["FRONT_ANALYZE"] = "FRONT_ANALYZE";
    STEPS_ENUM["ROTATE_DEVICE"] = "ROTATE_DEVICE";
    STEPS_ENUM["DEVICE_ANALYSIS_RESULTS"] = "DEVICE_ANALYSIS_RESULTS";
    STEPS_ENUM["BEFORE_ANALYZE_CABLE_COAX"] = "BEFORE_ANALYZE_CABLE_COAX";
    STEPS_ENUM["BEFORE_ANALYZE_CABLE_HDMI"] = "BEFORE_ANALYZE_CABLE_HDMI";
    STEPS_ENUM["BEFORE_ANALYZE_CABLE_POWER"] = "BEFORE_ANALYZE_CABLE_POWER";
    STEPS_ENUM["CABLE_ANALYZE_COAX"] = "CABLE_ANALYZE_COAX";
    STEPS_ENUM["CABLE_ANALYZE_POWER"] = "CABLE_ANALYZE_POWER";
    STEPS_ENUM["CABLE_ANALYZE_HDMI"] = "CABLE_ANALYZE_HDMI";
    STEPS_ENUM["GUID_PLUG_CABLE_COAX"] = "GUID_PLUG_CABLE_COAX";
    STEPS_ENUM["GUID_PLUG_CABLE_HDMI"] = "GUID_PLUG_CABLE_HDMI";
    STEPS_ENUM["GUID_PLUG_CABLE_POWER"] = "GUID_PLUG_CABLE_POWER";
    STEPS_ENUM["PLUG_CABLE_COAX"] = "PLUG_CABLE_COAX";
    STEPS_ENUM["PLUG_CABLE_HDMI"] = "PLUG_CABLE_HMDI";
    STEPS_ENUM["PLUG_CABLE_POWER"] = "PLUG_CABLE_POWER";
    STEPS_ENUM["ALL_CABLES_CONNECTED"] = "ALL_CABLES_CONNECTED";
    STEPS_ENUM["CABLES_ARE_NOT_CONNECTED_GUIDANCE_ME"] = "CABLES_ARE_NOT_CONNECTED_GUIDANCE_ME";
    STEPS_ENUM["PRESS_POWER_BUTTON"] = "PRESS_POWER_BUTTON";
    STEPS_ENUM["FIND_REMOTE"] = "FIND_REMOTE";
    STEPS_ENUM["PREPARE_REMOTE"] = "PREPARE_REMOTE";
    STEPS_ENUM["ANALYZE_REMOTE"] = "ANALYZE_REMOTE";
    STEPS_ENUM["REMOTE_ANALYSIS_RESULTS"] = "REMOTE_ANALYSIS_RESULTS";
    STEPS_ENUM["WARM_TRANSFER"] = "WARM_TRANSFER";
    STEPS_ENUM["RESTART_APPLICATION"] = "RESTART_APPLICATION";
})(STEPS_ENUM = exports.STEPS_ENUM || (exports.STEPS_ENUM = {}));
var FRONTIER_STEPS_ENUMS;
(function (FRONTIER_STEPS_ENUMS) {
    FRONTIER_STEPS_ENUMS["GUIDANCE"] = "GUIDANCE";
    FRONTIER_STEPS_ENUMS["REAR_ANALYZE"] = "REAR_ANALYZE";
    FRONTIER_STEPS_ENUMS["FRONT_ANALYZE"] = "FRONT_ANALYZE";
    FRONTIER_STEPS_ENUMS["ROTATE_DEVICE"] = "ROTATE_DEVICE";
    FRONTIER_STEPS_ENUMS["DEVICE_ANALYSIS_RESULTS"] = "DEVICE_ANALYSIS_RESULTS";
    FRONTIER_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_COAX"] = "BEFORE_ANALYZE_CABLE_COAX";
    FRONTIER_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_POWER"] = "BEFORE_ANALYZE_CABLE_POWER";
    FRONTIER_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_LAN"] = "BEFORE_ANALYZE_CABLE_LAN";
    FRONTIER_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_ONT"] = "BEFORE_ANALYZE_CABLE_ONT";
    FRONTIER_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_BROADBAND"] = "BEFORE_ANALYZE_CABLE_BROADBAND";
    FRONTIER_STEPS_ENUMS["CABLE_ANALYZE_COAX"] = "CABLE_ANALYZE_COAX";
    FRONTIER_STEPS_ENUMS["CABLE_ANALYZE_POWER"] = "CABLE_ANALYZE_POWER";
    FRONTIER_STEPS_ENUMS["CABLE_ANALYZE_LAN"] = "CABLE_ANALYZE_LAN";
    FRONTIER_STEPS_ENUMS["CABLE_ANALYZE_ONT"] = "CABLE_ANALYZE_ONT";
    FRONTIER_STEPS_ENUMS["CABLE_ANALYZE_BROADBAND"] = "CABLE_ANALYZE_BROADBAND";
    FRONTIER_STEPS_ENUMS["GUID_PLUG_CABLE_COAX"] = "GUID_PLUG_CABLE_COAX";
    FRONTIER_STEPS_ENUMS["GUID_PLUG_CABLE_POWER"] = "GUID_PLUG_CABLE_POWER";
    FRONTIER_STEPS_ENUMS["GUID_PLUG_CABLE_LAN"] = "GUID_PLUG_CABLE_LAN";
    FRONTIER_STEPS_ENUMS["GUID_PLUG_CABLE_ONT"] = "GUID_PLUG_CABLE_ONT";
    FRONTIER_STEPS_ENUMS["GUID_PLUG_CABLE_BROADBAND"] = "GUID_PLUG_CABLE_BROADBAND";
    FRONTIER_STEPS_ENUMS["PLUG_CABLE_COAX"] = "PLUG_CABLE_COAX";
    FRONTIER_STEPS_ENUMS["PLUG_CABLE_POWER"] = "PLUG_CABLE_POWER";
    FRONTIER_STEPS_ENUMS["PLUG_CABLE_LAN"] = "PLUG_CABLE_LAN";
    FRONTIER_STEPS_ENUMS["PLUG_CABLE_ONT"] = "PLUG_CABLE_ONT";
    FRONTIER_STEPS_ENUMS["PLUG_CABLE_BROADBAND"] = "PLUG_CABLE_BROADBAND";
    FRONTIER_STEPS_ENUMS["ALL_CABLES_CONNECTED"] = "ALL_CABLES_CONNECTED";
    FRONTIER_STEPS_ENUMS["CABLES_ARE_NOT_CONNECTED_GUIDANCE_ME"] = "CABLES_ARE_NOT_CONNECTED_GUIDANCE_ME";
    FRONTIER_STEPS_ENUMS["PRESS_POWER_BUTTON"] = "PRESS_POWER_BUTTON";
    FRONTIER_STEPS_ENUMS["WARM_TRANSFER"] = "WARM_TRANSFER";
    FRONTIER_STEPS_ENUMS["RESTART_APPLICATION"] = "RESTART_APPLICATION";
    FRONTIER_STEPS_ENUMS["LED_STATUS_ANALYZE"] = "LED_STATUS_ANALYZE";
    FRONTIER_STEPS_ENUMS["LED_STATUS_ANALYSIS_RESULT"] = "LED_STATUS_ANALYSIS_RESULT";
    FRONTIER_STEPS_ENUMS["STICKER_ANALYZE"] = "STICKER_ANALYZE";
    FRONTIER_STEPS_ENUMS["STICKER_ANALYSIS_RESULT"] = "STICKER_ANALYSIS_RESULT";
    FRONTIER_STEPS_ENUMS["STICKER_CAPTURE"] = "STICKER_CAPTURE";
    FRONTIER_STEPS_ENUMS["STICKER_RESULT"] = "STICKER_RESULT";
    FRONTIER_STEPS_ENUMS["STICKER_GUIDE"] = "STICKER_GUIDE";
    FRONTIER_STEPS_ENUMS["SUPPORT_CENTER"] = "SUPPORT_CENTER";
    FRONTIER_STEPS_ENUMS["WIFI_GUIDE_PAGE"] = "WIFI_GUIDE_PAGE";
    FRONTIER_STEPS_ENUMS["ADDITIONAL_ASSIST_PAGE_DONE"] = "ADDITIONAL_ASSIST_PAGE_DONE";
})(FRONTIER_STEPS_ENUMS = exports.FRONTIER_STEPS_ENUMS || (exports.FRONTIER_STEPS_ENUMS = {}));
var VERIZON_STEPS_ENUMS;
(function (VERIZON_STEPS_ENUMS) {
    VERIZON_STEPS_ENUMS["GUIDANCE"] = "GUIDANCE";
    VERIZON_STEPS_ENUMS["BOX_CONTENTS"] = "BOX_CONTENTS";
    VERIZON_STEPS_ENUMS["REAR_ANALYZE"] = "REAR_ANALYZE";
    VERIZON_STEPS_ENUMS["FRONT_ANALYZE"] = "FRONT_ANALYZE";
    VERIZON_STEPS_ENUMS["ROTATE_DEVICE"] = "ROTATE_DEVICE";
    VERIZON_STEPS_ENUMS["DEVICE_ANALYSIS_RESULTS"] = "DEVICE_ANALYSIS_RESULTS";
    VERIZON_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_COAX"] = "BEFORE_ANALYZE_CABLE_COAX";
    VERIZON_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_POWER"] = "BEFORE_ANALYZE_CABLE_POWER";
    VERIZON_STEPS_ENUMS["BEFORE_ANALYZE_CABLE_WAN"] = "BEFORE_ANALYZE_CABLE_WAN";
    VERIZON_STEPS_ENUMS["CABLE_ANALYZE_COAX"] = "CABLE_ANALYZE_COAX";
    VERIZON_STEPS_ENUMS["CABLE_ANALYZE_POWER"] = "CABLE_ANALYZE_POWER";
    VERIZON_STEPS_ENUMS["CABLE_ANALYZE_WAN"] = "CABLE_ANALYZE_WAN";
    VERIZON_STEPS_ENUMS["GUID_PLUG_CABLE_COAX"] = "GUID_PLUG_CABLE_COAX";
    VERIZON_STEPS_ENUMS["GUID_PLUG_CABLE_POWER"] = "GUID_PLUG_CABLE_POWER";
    VERIZON_STEPS_ENUMS["GUID_PLUG_CABLE_WAN"] = "GUID_PLUG_CABLE_WAN";
    VERIZON_STEPS_ENUMS["PLUG_CABLE_COAX"] = "PLUG_CABLE_COAX";
    VERIZON_STEPS_ENUMS["PLUG_CABLE_POWER"] = "PLUG_CABLE_POWER";
    VERIZON_STEPS_ENUMS["PLUG_CABLE_WAN"] = "PLUG_CABLE_WAN";
    VERIZON_STEPS_ENUMS["ALL_CABLES_CONNECTED"] = "ALL_CABLES_CONNECTED";
    VERIZON_STEPS_ENUMS["CABLES_ARE_NOT_CONNECTED_GUIDANCE_ME"] = "CABLES_ARE_NOT_CONNECTED_GUIDANCE_ME";
    VERIZON_STEPS_ENUMS["INTERNET_INIT"] = "INTERNET_INIT";
    VERIZON_STEPS_ENUMS["WARM_TRANSFER"] = "WARM_TRANSFER";
    VERIZON_STEPS_ENUMS["RESTART_APPLICATION"] = "RESTART_APPLICATION";
    VERIZON_STEPS_ENUMS["LED_STATUS_ANALYZE"] = "LED_STATUS_ANALYZE";
    VERIZON_STEPS_ENUMS["LED_STATUS_ANALYSIS_RESULT"] = "LED_STATUS_ANALYSIS_RESULT";
    VERIZON_STEPS_ENUMS["STICKER_ANALYZE"] = "STICKER_ANALYZE";
    VERIZON_STEPS_ENUMS["STICKER_ANALYSIS_RESULT"] = "STICKER_ANALYSIS_RESULT";
    VERIZON_STEPS_ENUMS["STICKER_CAPTURE"] = "STICKER_CAPTURE";
    VERIZON_STEPS_ENUMS["STICKER_RESULT"] = "STICKER_RESULT";
    VERIZON_STEPS_ENUMS["STICKER_GUIDE"] = "STICKER_GUIDE";
    VERIZON_STEPS_ENUMS["SUPPORT_CENTER"] = "SUPPORT_CENTER";
    VERIZON_STEPS_ENUMS["WIFI_GUIDE_PAGE"] = "WIFI_GUIDE_PAGE";
    VERIZON_STEPS_ENUMS["ADDITIONAL_ASSIST_PAGE_DONE"] = "ADDITIONAL_ASSIST_PAGE_DONE";
})(VERIZON_STEPS_ENUMS = exports.VERIZON_STEPS_ENUMS || (exports.VERIZON_STEPS_ENUMS = {}));
exports.EVE_SUCCESS_STEPS = [
    { name: STEPS_ENUM.REMOTE_ANALYSIS_RESULTS, code: EveReportStepCodes.NEXT },
    { name: FRONTIER_STEPS_ENUMS.ADDITIONAL_ASSIST_PAGE_DONE, code: EveReportStepCodes.NEXT }
];
exports.EVE_WARM_TRANSFER_REQUEST_STEPS = [
    { name: STEPS_ENUM.WARM_TRANSFER, code: EveReportStepCodes.WARM_TRANSFER },
    { name: FRONTIER_STEPS_ENUMS.WARM_TRANSFER, code: EveReportStepCodes.WARM_TRANSFER }
];
var EVE_SESSION_STATUS;
(function (EVE_SESSION_STATUS) {
    EVE_SESSION_STATUS["FINISHED"] = "FINISHED";
    EVE_SESSION_STATUS["WARM_TRANSFER_REQUESTED"] = "WARM TRANSFER REQUESTED";
    EVE_SESSION_STATUS["WARM_TRANSFER_CONNECTED"] = "WARM_TRANSFER_CONNECTED";
    EVE_SESSION_STATUS["ABANDONED"] = "ABANDONED";
})(EVE_SESSION_STATUS = exports.EVE_SESSION_STATUS || (exports.EVE_SESSION_STATUS = {}));
exports.reasonForClosing = ReasonForClosing;
exports.inviteMethods = InviteMethod;
exports.modes = MeetingMode;
exports.switchModeReasons = SwitchModeReason;
exports.userInteractionTriggerActions = UserInteractionTriggerAction;
exports.failureTriggerActions = FailureTriggerAction;
exports.userTypes = UserType;
exports.supportCheckResults = SupportCheckResult;
exports.referrers = Referrer;
var SESSION_SOURCE;
(function (SESSION_SOURCE) {
    SESSION_SOURCE["INVITE_PAGE"] = "INVITE_PAGE";
    SESSION_SOURCE["QUICK_LAUNCH"] = "QUICK_LAUNCH";
    SESSION_SOURCE["IVR"] = "IVR";
    SESSION_SOURCE["SUPPORT_PORTAL"] = "SUPPORT_PORTAL";
    SESSION_SOURCE["INVITE_WIZARD"] = "iw";
    SESSION_SOURCE["PUBLIC_API"] = "api";
    SESSION_SOURCE["SELF_SERVICE"] = "SELF_SERVICE";
    SESSION_SOURCE["AI"] = "AI";
    SESSION_SOURCE["VJ"] = "VJ";
    SESSION_SOURCE["EVE"] = "EVE";
    SESSION_SOURCE["UNKNOWN"] = "UNKNOWN";
})(SESSION_SOURCE = exports.SESSION_SOURCE || (exports.SESSION_SOURCE = {}));
var SESSION_ECOSYSTEM;
(function (SESSION_ECOSYSTEM) {
    SESSION_ECOSYSTEM["STANDALONE"] = "STANDALONE";
    SESSION_ECOSYSTEM["MINI"] = "MINI";
})(SESSION_ECOSYSTEM = exports.SESSION_ECOSYSTEM || (exports.SESSION_ECOSYSTEM = {}));
var RECORDING_STATUS;
(function (RECORDING_STATUS) {
    RECORDING_STATUS["ready"] = "ready";
    RECORDING_STATUS["starting"] = "starting";
    RECORDING_STATUS["started"] = "started";
    RECORDING_STATUS["stopping"] = "stopping";
    RECORDING_STATUS["failed"] = "failed";
})(RECORDING_STATUS = exports.RECORDING_STATUS || (exports.RECORDING_STATUS = {}));
exports.SESSION_SOURCE_MAP = (_a = {
        INVITE_PAGE: 'Invite page',
        QUICK_LAUNCH: 'Quick Launch',
        IVR: 'IVR',
        SUPPORT_PORTAL: 'Support Portal',
        iw: 'Invite Wizard',
        api: 'API',
        SELF_SERVICE: 'Self Service'
    },
    _a[SESSION_SOURCE.AI] = 'AI',
    _a[SESSION_SOURCE.VJ] = 'VJ',
    _a[SESSION_SOURCE.EVE] = 'Eve',
    _a[SESSION_SOURCE.UNKNOWN] = 'Unknown',
    _a);
var TEXT_HISTORY_ROOM_TYPES;
(function (TEXT_HISTORY_ROOM_TYPES) {
    TEXT_HISTORY_ROOM_TYPES["visualJourney"] = "VISUAL_JOURNEY";
})(TEXT_HISTORY_ROOM_TYPES = exports.TEXT_HISTORY_ROOM_TYPES || (exports.TEXT_HISTORY_ROOM_TYPES = {}));
exports.SWITCH_MODE_REASONS_MAP = {};
var INTERACTION_REASON = { reason: SwitchModeReason.userInteraction, propName: 'userInteractionTriggerActions' };
var FAILURE_REASON = { reason: SwitchModeReason.failure, propName: 'failureCause' };
exports.SWITCH_MODE_REASONS_MAP[UserInteractionTriggerAction.buttonClickDuringSession] = INTERACTION_REASON;
exports.SWITCH_MODE_REASONS_MAP[UserInteractionTriggerAction.buttonClickDuringInitiation] = INTERACTION_REASON;
exports.SWITCH_MODE_REASONS_MAP[UserInteractionTriggerAction.bandwidthPopup] = INTERACTION_REASON;
exports.SWITCH_MODE_REASONS_MAP[FailureTriggerAction.dashboardNetworkIssue] = FAILURE_REASON;
exports.SWITCH_MODE_REASONS_MAP[FailureTriggerAction.clientNetworkIssue] = FAILURE_REASON;
exports.SWITCH_MODE_REASONS_MAP[FailureTriggerAction.unableToPublish] = FAILURE_REASON;
exports.SWITCH_MODE_REASONS_MAP[FailureTriggerAction.lowBandwidthConnection] = FAILURE_REASON;
exports.SURVEY_ANSWER_MAX_LENGTH = 2000;
var ObserverInvitationMethod;
(function (ObserverInvitationMethod) {
    ObserverInvitationMethod["EMAIL"] = "email";
    ObserverInvitationMethod["SMS"] = "sms";
    ObserverInvitationMethod["LINK"] = "link";
})(ObserverInvitationMethod = exports.ObserverInvitationMethod || (exports.ObserverInvitationMethod = {}));
var ObserverStatusMethod;
(function (ObserverStatusMethod) {
    ObserverStatusMethod["INVITE_SMS_SENT"] = "sms sent";
    ObserverStatusMethod["INVITE_EMAIL_SENT"] = "email sent";
    ObserverStatusMethod["JOINED"] = "joined";
    ObserverStatusMethod["LEFT"] = "left";
})(ObserverStatusMethod = exports.ObserverStatusMethod || (exports.ObserverStatusMethod = {}));
var AppLauncherTypesEnum;
(function (AppLauncherTypesEnum) {
    AppLauncherTypesEnum["INVITE"] = "INVITE";
    AppLauncherTypesEnum["DASHBOARD"] = "DASHBOARD";
    AppLauncherTypesEnum["CLIENT"] = "CLIENT";
})(AppLauncherTypesEnum = exports.AppLauncherTypesEnum || (exports.AppLauncherTypesEnum = {}));
var ArMeasurementActionTypesEnum;
(function (ArMeasurementActionTypesEnum) {
    ArMeasurementActionTypesEnum["ACTIVATE_MEASURE"] = "ACTIVATE MEASURE";
    ArMeasurementActionTypesEnum["END_MEASURE"] = "END MEASURE";
    ArMeasurementActionTypesEnum["ADD_POINT"] = "ADD POINT";
    ArMeasurementActionTypesEnum["MEASURE_DETECTED"] = "MEASURE DETECTED";
    ArMeasurementActionTypesEnum["COPY_DISTANCE"] = "COPY DISTANCE";
    ArMeasurementActionTypesEnum["UNDO_POINT"] = "UNDO POINT";
})(ArMeasurementActionTypesEnum = exports.ArMeasurementActionTypesEnum || (exports.ArMeasurementActionTypesEnum = {}));
var WarmTransferRoomStatus;
(function (WarmTransferRoomStatus) {
    WarmTransferRoomStatus["UNKNOWN"] = "UNKNOWN";
    WarmTransferRoomStatus["NOT_READY"] = "NOT_READY";
    WarmTransferRoomStatus["EXPIRED"] = "EXPIRED";
    WarmTransferRoomStatus["READY"] = "READY";
})(WarmTransferRoomStatus = exports.WarmTransferRoomStatus || (exports.WarmTransferRoomStatus = {}));

//# sourceMappingURL=room.constants.js.map
